import React, { FC, useState } from 'react';

import { Container, Typography } from '@mui/material';
import cn from 'classnames';

import { Background, Faq } from '../../types';
import useTextStyles from '../../utils/textStyles';
import SingleAccordion from './SingleAccordion';
import useStyles from './styles';

interface AccordionsBlockProps {
  data: Faq;
}

const AccordionsBlock: FC<AccordionsBlockProps> = ({ data }) => {
  const { background, heading, questions } = data;

  const classes = useStyles(background)();
  const textClasses = useTextStyles();

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const handleSelect = (index) => {
    setSelectedIndex((prevState) => (prevState !== index ? index : -1));
  };

  return (
    <div
      className={cn(
        classes.wrapper,
        background === Background.Dark ? 'dark-block' : 'light-block',
        'accordions-block',
      )}
    >
      <Container className={classes.container}>
        <Typography align="center" variant="h2" className={cn(classes.title, textClasses.h2)}>
          {heading}
        </Typography>
        <div className={classes.accordionsWrapper}>
          {Boolean(questions?.length) &&
            questions?.map((item, i) => (
              <SingleAccordion
                id={i}
                title={item?.title}
                description={item?.description}
                isOpened={selectedIndex === i}
                handleOpen={handleSelect}
              />
            ))}
        </div>
      </Container>
    </div>
  );
};

export default AccordionsBlock;
